import React, { useState } from "react"
import { GetEmployeeBankDetailInterface } from "@type/employees.types"
import AdditionalDetail from "./AdditionalDetail"
import BankDetail from "./BankDetail"
import AdditionalDataTable from "./AdditionalDataTable"
import EmployeeBankContext from "./AdditionalDetailContext"
import useSchedulesQueryParams from "hooks/useSchedulesQueryParams"
import { useEmployeeScheduleDefaults } from "hooks/useScheduleDefaults"

const AdditionDetail: React.FC = () => {
	const [bankDetail, setBankDetail] = useState<GetEmployeeBankDetailInterface | null>(null)
	useEmployeeScheduleDefaults()
	const { selectedEmployee = "" } = useSchedulesQueryParams()

	const handleBankDetailHandler = (bankData: GetEmployeeBankDetailInterface | null) => {
		setBankDetail(bankData)
	}

	return (
		<>
			<EmployeeBankContext.Provider value={{ bankDetail, handleBankDetailHandler }}>
				<div className="flex flex-col gap-y-5">
					<div className="grid grid-cols-12 gap-x-5">
						<div className="col-span-5">
							<BankDetail selected={selectedEmployee} />
						</div>
						<div className="col-span-3">
							<AdditionalDetail selected={selectedEmployee} />
						</div>
					</div>
					<AdditionalDataTable />
				</div>
			</EmployeeBankContext.Provider>
		</>
	)
}

export default AdditionDetail
